import { dynamicElementsButtonKey } from '@epicuro-next/constants/dynamic-elements';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export const shareListButtonItem: IDynamicItem = {
  contentTypeId: dynamicElementsButtonKey,
  styles: {
    classes: [
      'btn-light',
      'rounded-circle',
      'position-absolute',
      'right-0',
      'ml-1',
    ],
    variables: {
      '--btn-dynamic-padding': '0',
      '--btn-dynamic-icon-width': '1.6875rem',
      '--btn-dynamic-icon-height': '1.6875rem',
      '--btn-dynamic-icon-font-size': '0.75rem',
    },
  },
  inputs: {
    icon: ['fas', 'link'],
    action: 'share-list',
    tooltip: '@@copyToClipboardTooltip',
  },
};
